/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Returns__Defective_ProductsInputs */

const en_help_center__refund_policy__returns__defective_products = /** @type {((inputs: Help_Center__Refund_Policy__Returns__Defective_ProductsInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Returns__Defective_ProductsInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Returns__Defective_ProductsInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Defective Products: If you receive a defective or damaged product, contact us within 48 hours of delivery for replacement or refund.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Returns__Defective_ProductsInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Defective Products:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " If you receive a defective or damaged product, contact us within 48 hours of delivery for replacement or refund." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Defective Products: If you receive a defective or damaged product, contact us within 48 hours of delivery for replacement or refund." |
*
* @param {Help_Center__Refund_Policy__Returns__Defective_ProductsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__returns__defective_products = /** @type {((inputs?: Help_Center__Refund_Policy__Returns__Defective_ProductsInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Returns__Defective_ProductsInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Returns__Defective_ProductsInputs, { locale?: "en" }, { strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Returns__Defective_ProductsInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__returns__defective_products(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Returns__Defective_ProductsInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__returns__defective_products.parts === "function" ? en_help_center__refund_policy__returns__defective_products.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__returns__defective_products(inputs) }]
			})
		}
	)
);